export enum PageActionsPosition {
  Between = 'between',
  Start = 'start',
  End = 'end',
}
